"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrivacySecurity = PrivacySecurity;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function PrivacySecurity(_ref) {
  var id = _ref.id,
    show = _ref.show,
    onHide = _ref.onHide;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, {
    id: id,
    show: show,
    size: "lg",
    centered: true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Header, {
    className: "bg-info text-white modal-variant"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "modal-title"
  }, "Privacy & Security")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, {
    className: ""
  }, /*#__PURE__*/_react.default.createElement("p", null, "To better personalize the content we share with you, we use cookies and other tools to track your interactions within this site and other sites built on your behalf. By logging in, you consent to our use of these tools to measure and document your activity on this site and any connected sites. We do not ever share or resell this information with third parties."), /*#__PURE__*/_react.default.createElement("p", null, "Additionally, our highest priority is keeping this site (and the data presented therein) safe and secure. To this end, we use a highly secure Amazon Web Services server facility that uses the same secure AES-192 bit encryption in use at major banks and financial institutions worldwide. We perform regular security audits and have applied other industry leading security solutions and practices to protect our dedicated servers and the platform application.")), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Footer, {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
    variant: "light",
    type: "button",
    className: "shadow-none ",
    onClick: onHide
  }, "Ok"))));
}
var _default = PrivacySecurity;
exports.default = _default;